'use strict';

exports.relativePath = {
    customersInfo: 'api/customers',
    analytics: 'api/data'
};